import { createTheme } from "@mui/material/styles";
import * as Colors from "./colors";
import type {} from "@mui/x-date-pickers/themeAugmentation";

const theme = createTheme({
  components: {
    MuiDialogContent: {
      defaultProps: {
        style: {
          paddingTop: 0,
          paddingBottom: 0,
        },
      },
    },
    MuiButton: {
      defaultProps: {
        style: {
          fontFamily: "Avenir-Medium",
          fontSize: 14,
        },
      },
      styleOverrides: {
        contained: {
          color: Colors.TEXT,
        },
        outlined: {
          color: Colors.PRIMARY,
          borderColor: Colors.BUTTON_BORDER_COLOR,
        },
      },
    },
    MuiFormHelperText: {
      defaultProps: {
        style: {
          marginTop: 0,
          fontSize: 12,
          lineHeight: 1.4,
        },
      },
    },
    MuiInputLabel: {
      defaultProps: {
        style: {
          fontFamily: "Avenir-Medium",
          fontSize: 16,
          fontWeight: "normal",
        },
      },
    },
  },
  palette: {
    primary: {
      main: Colors.PRIMARY,
      light: Colors.PRIMARY_VARIANT,
    },
    secondary: {
      main: Colors.SECONDARY,
      light: Colors.SECONDARY_VARIANT,
    },
    background: {
      default: Colors.BACKGROUND,
    },
    error: {
      main: Colors.ERROR,
    },
    text: {
      primary: Colors.PRIMARY,
      secondary: Colors.TEXT_SECONDARY,
    },
  },
  typography: {
    fontFamily: "Avenir-Medium",
    h1: {
      fontFamily: "Avenir-Black",
      fontSize: 96,
    },
    h2: {
      fontFamily: "Avenir-Black",
      fontSize: 60,
    },
    h3: {
      fontFamily: "Avenir-Black",
      fontSize: 48,
    },
    h4: {
      fontFamily: "Avenir-Black",
      fontSize: 24,
    },
    h5: {
      fontFamily: "Avenir-Black",
      fontSize: 24,
    },
    h6: {
      fontFamily: "Avenir-Black",
      fontSize: 16,
      letterSpacing: 0.5,
    },
    subtitle1: {
      fontFamily: "Avenir-Book",
      fontSize: 14,
    },
    subtitle2: {
      fontFamily: "Avenir-Book",
      fontSize: 14,
    },
    body1: {
      fontFamily: "Helvetica-Regular",
      fontSize: 16,
      fontWeight: "bold",
    },
    body2: {
      fontFamily: "Avenir-Book",
      fontSize: 14,
      letterSpacing: 0.25,
    },
    caption: {
      fontFamily: "Helvetica-Regular",
      fontSize: 14,
    },
    overline: {
      fontFamily: "Avenir-Medium",
      fontSize: 10,
      letterSpacing: 1.5,
    },
  },
});

export default theme;
